// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__w81m7","icon":"styles_icon__3aGAU"};